import { render, staticRenderFns } from "./BaseWizardFooter.vue?vue&type=template&id=29cab368&"
import script from "./BaseWizardFooter.vue?vue&type=script&lang=js&"
export * from "./BaseWizardFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports